module.exports = __webpack_public_path__ + "static/media/dashboard.14753ec7.svg";